module.exports = __webpack_public_path__ + "img/KinokoTable23.306600d4.jpg";